import RestClient from './client'

export default new RestClient()
